import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig';

import {
  LOGIN,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  USER_ACTIVITY,
  JOBS_APPLICATION_METRICS,
  SUBSCRIPTION_DETAILS,
  TESTIMONIALS,
  COMPANIES,
  INVOICES,
  INVOICE_DETAILS,
  CAMPAIGNS,
  PAYMENT_PACKAGES,
} from 'constants/RoutesConstants';

export const publicRoutes = [
  {
    key: 'login',
    path: `${AUTH_PREFIX_PATH}/login`,
    component: LOGIN,
  },
  {
    key: 'forgot-password',
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: FORGOT_PASSWORD,
  },
  {
    key: 'reset-password',
    path: `${AUTH_PREFIX_PATH}/reset-password/:token`,
    component: RESET_PASSWORD,
  },
];

export const protectedRoutes = {
  SUPER_ADMIN: [
    {
      key: 'user-activity',
      path: `${APP_PREFIX_PATH}/user-activity`,
      component: USER_ACTIVITY,
    },
    {
      key: 'job-and-application-matrices',
      path: `${APP_PREFIX_PATH}/jobs-and-applications-matrices`,
      component: JOBS_APPLICATION_METRICS,
    },
    {
      key: 'subscription-details',
      path: `${APP_PREFIX_PATH}/subscription-details`,
      component: SUBSCRIPTION_DETAILS,
    },
    {
      key: 'companies',
      path: `${APP_PREFIX_PATH}/companies`,
      component: COMPANIES,
    },
    {
      key: 'campaigns',
      path: `${APP_PREFIX_PATH}/campaigns`,
      component: CAMPAIGNS,
    },
    {
      key: 'invoices',
      path: `${APP_PREFIX_PATH}/invoices`,
      component: INVOICES,
    },
    {
      key: 'invoice-details',
      path: `${APP_PREFIX_PATH}/invoices/:companyId`,
      component: INVOICE_DETAILS,
    },
    {
      key: 'testimonials',
      path: `${APP_PREFIX_PATH}/testimonials`,
      component: TESTIMONIALS,
    },
    {
      key: 'payment-packages',
      path: `${APP_PREFIX_PATH}/payment-packages`,
      component: PAYMENT_PACKAGES,
    },
  ],
};
